var map = {
	"./external-links-en-au-ConsultAA.json": 21245,
	"./external-links-en-au-ConsultUK.json": 35605,
	"./external-links-en-au-DWPUK.json": 73484,
	"./external-links-en-au-ENG-NHS.json": 58271,
	"./external-links-en-au-HDA.json": 41908,
	"./external-links-en-au-NHS.json": 80465,
	"./external-links-en-au-WALES-NHS.json": 1749
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54338;